import { PATH } from '#const/path';
import { useCoachMark } from '#hooks/useCoachMark';
import { DashboardCustomerInfo } from '#organisims';
import { PageContainer } from '#pages/Dashboard/styles';
import { useDashboard } from '#providers/Dashboard';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useNavigate } from 'react-router';
import { Header, IconContainer, SettingIcon } from './styles';

export function DashboardCustomerPage() {
  const { customerDetail } = useDashboard();
  const navigate = useNavigate();

  const { isCoachMark } = useCoachMark();

  return (
    <PageContainer>
      <PrevHeaderBarWithTitleTemplate
        headerbarStyle={{ zIndex: isCoachMark ? '0' : '10' }}
        title={'회원관리'}
        defaultBackground
        rightContents={
          <IconContainer
            onClick={() => {
              navigate(PATH.DASHBOARD_SETTING);
            }}
          >
            <SettingIcon />
          </IconContainer>
        }
      >
        <Header>
          <DashboardCustomerInfo
            customerDetail={customerDetail}
            type="customer-detail"
          />
        </Header>
      </PrevHeaderBarWithTitleTemplate>
    </PageContainer>
  );
}
